import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import axios from 'axios';
import Swal from 'sweetalert2';
import { API_URL } from '../../../api/api';
import { useNavigate } from 'react-router-dom';

const ManageTodayCollSearchLayer = () => {
    const token = localStorage.getItem('token');
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    const navigate = useNavigate();
    const [states, setStates] = useState([]);
    const [districts, setDistricts] = useState([]);
    const [branches, setBranches] = useState([]);
    const [groups, setGroups] = useState([]);

    const [form, setForm] = useState({
        state: '',
        district: '',
        branch: '',
        group: '',
        reportType: '',
        collectionday: ''
    });

    useEffect(() => {
        fetchStates();
    }, []);

    const fetchStates = async () => {
        try {
            const res = await axios.get(`${API_URL}/state`);
            setStates(res.data);
        } catch (error) {
            console.error("Error fetching states", error);
            Swal.fire("Error", "Failed to load states", "error");
        }
    };

    const handleSearch = () => {
        const { branch, group, reportType } = form;

        if (!branch || !group || !reportType) {
            return Swal.fire("Error", "Please fill all fields before searching", "warning");
        }

        const query = new URLSearchParams({
            branch,
            group,
            type: reportType
        }).toString();

        let url = '';
        // if (reportType.toLowerCase() === 'cash') {
        //     url = `/manage-today-cash-coll?${query}`;
        // } else {
        //     url = `/manage-today-product-coll?${query}`;
        // }
        if (reportType.toLowerCase() === 'cash') {
            url = `/software/manage-today-cash-coll?${query}`;
        } else {
            url = `/software/manage-today-product-coll?${query}`;
        }
        window.open(url, '_blank');
    };


    const handleStateChange = (option) => {
        const selectedState = states.find(state => state.state_code === option.value);
        setForm({ ...form, state: option.value, district: '', branch: '', group: '' });
        setDistricts(selectedState?.districts ?? []);
        setBranches([]);
        setGroups([]);
    };

    const handleDistrictChange = async (option) => {
        setForm(prev => ({ ...prev, district: option.value, branch: '', group: '' }));
        try {
            const districtSlug = option.value.toLowerCase();
            const res = await axios.get(`${API_URL}/districts/${districtSlug}/branches`);
            setBranches(res.data);
            setGroups([]);
        } catch (error) {
            console.error("Error fetching branches", error);
            Swal.fire("Error", "Failed to load branches", "error");
        }
    };

    const handleBranchChange = async (option) => {
        setForm(prev => ({ ...prev, branch: option.value, group: '' }));
        setGroups([]);
        try {
            const res = await axios.get(`${API_URL}/branches/${option.value}/groups`);
            setGroups(res.data);
        } catch (error) {
            console.error("Error fetching groups", error);
            Swal.fire("Error", "Failed to load groups", "error");
        }
    };

    const handleGroupChange = (option) => {
        setForm(prev => ({ ...prev, group: option.value }));
    };

    const toSelectOptions = (arr, labelKey = 'name', valueKey = 'id') =>
        arr.map(item => ({
            value: item[valueKey],
            label: item[labelKey],
        }));

    return (
        <div className="container py-4">
            <div className="card shadow-sm">
                <div className="card-header bg-primary text-white">
                    <p className="mb-0">📋 Meeting Sheet</p>
                </div>
                <div className="card-body">

                    <div className="row g-3">

                        {/* State */}
                        <div className="col-md-6">
                            <label className="form-label">State</label>
                            <Select
                                options={toSelectOptions(states, 'state_name', 'state_code')}
                                value={toSelectOptions(states, 'state_name', 'state_code').find(opt => opt.value === form.state)}
                                onChange={handleStateChange}
                                placeholder="Select State"
                            />
                        </div>

                        {/* District */}
                        <div className="col-md-6">
                            <label className="form-label">District</label>
                            <Select
                                options={toSelectOptions(districts, 'district', 'district')}
                                value={toSelectOptions(districts, 'district', 'district').find(opt => opt.value === form.district)}
                                onChange={handleDistrictChange}
                                placeholder="Select District"
                            />
                        </div>

                        {/* Branch */}
                        <div className="col-md-6">
                            <label className="form-label">Branch</label>
                            <Select
                                options={toSelectOptions(branches, 'branchname')}
                                value={toSelectOptions(branches, 'branchname').find(opt => opt.value === form.branch)}
                                onChange={handleBranchChange}
                                placeholder="Select Branch"
                            />
                        </div>

                        {/* Group */}
                        <div className="col-md-6">
                            <label className="form-label">Group</label>
                            <Select
                                options={toSelectOptions(groups, 'groupname')}
                                value={toSelectOptions(groups, 'groupname').find(opt => opt.value === form.group)}
                                onChange={handleGroupChange}
                                placeholder="Select Group"
                                isDisabled={!form.branch || groups.length === 0}
                            />
                        </div>

                        {/* Report Type (Radio) */}
                        <div className="col-md-6">
                            <label className="form-label d-block mb-2">Report Type</label>
                            <div className="d-flex gap-3">
                                {['Cash', 'Product'].map(type => (
                                    <div key={type} className="form-check">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="reportType"
                                            id={`reportType-${type}`}
                                            value={type}
                                            checked={form.reportType === type}
                                            onChange={(e) => setForm(prev => ({ ...prev, reportType: e.target.value }))}
                                        />
                                        <label className="form-check-label" htmlFor={`reportType-${type}`}>
                                            {type}
                                        </label>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Button */}
                        <div className="col-12 text-end">
                            <button className="btn btn-primary px-4" onClick={handleSearch}>
                                🔍 Search
                            </button>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default ManageTodayCollSearchLayer;
